import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ClinicClientReferencesDb extends GenericDB {
  /**
   * @param {string} clinicId
   * @param {string} integrationName
   */
  constructor(clinicId, integrationName) {
    super('', 'clinics.integrations.clinicsClientReferences');
    this.setClinicId(clinicId);
    this.setIntegrationName(integrationName);
  }

  setClinicId(clinicId) {
    this.clinicId = clinicId;
  }

  setIntegrationName(integrationName) {
    this.integrationName = integrationName;
  }

  getCollectionRef() {
    return collection(
      db,
      'clinics',
      this.clinicId,
      'integrations',
      this.integrationName,
      'clinicClientReferences',
    ).withConverter(this.#firestoreConverter);
  }

  #firestoreConverter = {
    toFirestore(data) {
      // eslint-disable-next-line no-unused-vars
      const { id, ...doc } = data;
      return doc;
    },
    fromFirestore(snapshot, options) {
      const data = snapshot.data(options);
      data.refId = snapshot.id;
      data.fullName = data.name;
      data.clinic = snapshot.ref.parent.parent.parent.parent.id;
      return data;
    },
  };
}
